module.exports = __webpack_public_path__ + "static/media/EditMenuColorTrack14Sept2020.43308435.gif";